import React from "react";
import { Card, Flex, Text } from "@radix-ui/themes";

export function Block({
  type,
  children,
}: {
  type: string;
  children: React.ReactNode;
}) {
  return (
    <Card>
      <Flex direction={"column"} gap={"2"}>
        <Text size="2">{type}</Text>
        <hr />
        {children}
      </Flex>
    </Card>
  );
}
